import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../reducers';
import { Wrapper } from './styles';
import Header from './Header';
import { closeDownloadGroupToast, downloadAll, downloadImportantAssets } from '../../containers/DownloadManager/actions';
import Content from '../../containers/DownloadGroupToast/Content';
import { DownloadGroupName } from '../../containers/DownloadManager/reducer';
import { downloadSelectedAssets } from '../../containers/DownloadManager/actions/download';
import { finishDownloadGroup, resetSelectedDownloadItems } from '../../containers/DownloadManager/actions/store';

interface DownloadGroupToastProps {
	isDisplayed: boolean;
	downloadedItems: number;
	totalItems: number;
	dispatch: Dispatch<StoreState>;
	startedDownloadGroup: DownloadGroupName | null;
	isCheckingForUpdates: boolean;
}

const DownloadGroupToast = ({
	isDisplayed,
	downloadedItems,
	totalItems,
	dispatch,
	startedDownloadGroup,
	isCheckingForUpdates,
}: DownloadGroupToastProps) => {
	const [isExpanded, setIsExpanded] = React.useState(true);

	return (
		<Wrapper isDisplayed={isDisplayed} data-gallery-slot="downloadGroupToast">
			<Header
				isToastExpanded={isExpanded}
				onToggle={() => setIsExpanded(!isExpanded)}
				downloadedItems={downloadedItems}
				totalItems={totalItems}
				onClose={() => dispatch(closeDownloadGroupToast())}
				isCheckingForUpdates={isCheckingForUpdates}
			/>
			{isExpanded &&
				<Content
					onContinueClick={() => {
						switch (startedDownloadGroup) {
							case DownloadGroupName.IMPORTANT:
								dispatch(downloadImportantAssets());
								break;
							case DownloadGroupName.ALL:
								dispatch(downloadAll());
								break;
							case DownloadGroupName.SELECTED:
								dispatch(downloadSelectedAssets());
								break;
							default:
								break;
						}
					}}
					onCancelClick={() => {
						switch (startedDownloadGroup) {
							case DownloadGroupName.IMPORTANT:
								dispatch(finishDownloadGroup(DownloadGroupName.IMPORTANT));
								break;
							case DownloadGroupName.ALL:
								dispatch(finishDownloadGroup(DownloadGroupName.ALL));
								break;
							case DownloadGroupName.SELECTED:
								dispatch(resetSelectedDownloadItems());
								break;
							default:
								break;
						}
					}}
					isCheckingForUpdates={isCheckingForUpdates}
				/>
			}
		</Wrapper>
	);
};

export default DownloadGroupToast;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DownloadGroupToast/index.tsx